import { Sprite, Texture } from 'pixi.js';
import Pipe from '../actors/Pipe';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Pipes {
  constructor(parent) {
    this.parent = parent;

    const emptyTexture = Texture.EMPTY;
    emptyTexture.orig.width = vars.layout.FRAME_WIDTH;
    emptyTexture.orig.height = vars.layout.FRAME_HEIGHT;
    this.container = new Sprite(emptyTexture);

    this.lastTime = 0;
    this.pipes = [];

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.spawnIntro();
    this.parent.addChild(this.container);
  }

  resize() {}

  spawnIntro() {
    const pipe = new Pipe(this.container, true);
    this.pipes.push(pipe);
  }

  startSpawn() {
    this.lastTime = ticker.totalTime;
    ticker.add(this.frameHandler);
  }

  frame() {
    for (let i = this.pipes.length - 1; i >= 0; i -= 1) {
      const pipe = this.pipes[i];
      pipe.sprite.position.x -= state.foregroundSpeed * ticker.speed;

      if (pipe.sprite.position.x + pipe.sprite.width / 2 < vars.layout.FRAME_WIDTH) {
        if (!pipe.registered) {
          pipe.registered = true;
        }
      }

      if (pipe.sprite.position.x < 0 - pipe.sprite.width / 2) {
        pipe.destroy();
        this.pipes.splice(i, 1);
      }
    }

    // Reset the time, so none get spawned, if the las pipe has not registered herself
    if (this.pipes.length > 0 && !this.pipes[this.pipes.length - 1].registered) {
      this.lastTime = ticker.totalTime;
    }
    // Spawn new pipes if needed
    const timeElapsed = ticker.totalTime - this.lastTime;
    if (timeElapsed > state.spawnDelay) {
      const pipe = new Pipe(this.container);
      this.pipes.push(pipe);
    }
  }

  gameover() {
    ticker.remove(this.frameHandler);
    for (let i = this.pipes.length - 1; i >= 0; i -= 1) {
      const pipe = this.pipes[i];
      pipe.out().then(() => {
        pipe.destroy();
        this.pipes.splice(i, 1);
      });
    }
  }

  replay() {
    this.lastTime = ticker.totalTime;
    ticker.add(this.frameHandler);
  }
}

export default Pipes;
